import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-152565f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminMenus" }
const _hoisted_2 = { id: "showmenus" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--baseline justify--start" }
const _hoisted_6 = { class: "md2 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex ml-4",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex ml-4" }
const _hoisted_10 = { class: "md2 flex ml-4" }
const _hoisted_11 = { class: "md2 flex ml-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "va-table-respoonsive"
}
const _hoisted_14 = {
  class: "va-table va-table--striped menusTable",
  style: {"width":"100%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["id"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_28 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_30 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_31 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_33 = { class: "selectPageSize" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du sikker på at du vil slette menupunktet?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_37 = { class: "md12 flex" }
const _hoisted_38 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Ændre menupunktets oplysninger for ")
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "md6 flex menuModal" }
const _hoisted_42 = { class: "md6 flex menuModal" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "md6 flex menuModal" }
const _hoisted_45 = { class: "md6 flex menuModal" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "md6 flex menuModal" }
const _hoisted_48 = { class: "md6 flex menuModal" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_51 = { id: "newmenus" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  class: "form"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "menuform-group" }
const _hoisted_56 = { class: "layout gutter--xl" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "flex md6" }
const _hoisted_59 = { class: "flex md6" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "flex md6" }
const _hoisted_62 = { class: "flex md6" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "flex md6" }
const _hoisted_65 = { class: "flex md6" }
const _hoisted_66 = { class: "row justify--center" }
const _hoisted_67 = { class: "flex" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Opret menupunktet")
const _hoisted_69 = { class: "tabHeight" }
const _hoisted_70 = { class: "row align--baseline justify--start" }
const _hoisted_71 = { class: "md2 flex ml-4" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = {
  key: 1,
  class: "va-table-respoonsive",
  style: {"min-height":"500px"}
}
const _hoisted_74 = {
  class: "va-table va-table--striped menutypesTable",
  style: {"width":"100%"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { hidden: "" }, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Titel"),
    /*#__PURE__*/_createElementVNode("th", null, "Sitedomæne"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", null, "Handlinger")
  ])
], -1))
const _hoisted_76 = ["id"]
const _hoisted_77 = ["id"]
const _hoisted_78 = ["id"]
const _hoisted_79 = ["id"]
const _hoisted_80 = ["id"]
const _hoisted_81 = ["id"]
const _hoisted_82 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "emphasizedText" }, "Er du vil slette menugruppen?")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "center" }, "Handlingen kan ikke fortrydes")
    ])
  ])
], -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_87 = { class: "editmenuTypeModal" }
const _hoisted_88 = { class: "md12 flex" }
const _hoisted_89 = {
  class: "mb-4",
  style: {"font-size":"1.2em"}
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Ændre oplysninger for menugruppe ")
const _hoisted_91 = { class: "row justify--space-around" }
const _hoisted_92 = { class: "md6 flex menuModal" }
const _hoisted_93 = { class: "md4 flex menuTypeModal" }
const _hoisted_94 = { class: "row justify--space-around" }
const _hoisted_95 = { class: "md4 flex menuTypeModal" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_97 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_98 = { id: "newmenutypes" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_100 = { key: 0 }
const _hoisted_101 = {
  key: 1,
  class: "form"
}
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "menutypeform-group" }
const _hoisted_104 = { class: "layout gutter--xl" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "flex md6" }
const _hoisted_107 = { class: "flex md6" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "flex md6" }
const _hoisted_110 = { class: "row justify--center" }
const _hoisted_111 = { class: "flex" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode("Opret menugruppe")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger menupunkter', 'Opret nyt menupunkt', 'Vis og rediger menugrupper', 'Opret ny menugruppe'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.menuSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menuSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findMenu()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "manage_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              rounded: false,
              class: "btn ml-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findMenu()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Statusfilter",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Domænefilter",
              modelValue: _ctx.menuDomainFilterValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.menuDomainFilterValue) = $event)),
              options: _ctx.menuDomainFilterOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_select, {
              label: "Menugruppefilter",
              disabled: _ctx.menuDomainFilterValue.value==='0',
              class: "ml-4",
              modelValue: _ctx.menuTypeTitleFilterValue,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.menuTypeTitleFilterValue) = $event)),
              options: _ctx.menuTypeTitleFilterOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["disabled", "modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnSort('title')))
                    }, "Titel"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.columnSort('domain')))
                    }, "Sitedomæne (FQDN)"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.columnSort('domain')))
                    }, "Link (FQDN)"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.columnSort('submenu')))
                    }, "Tilknyttet under menu"),
                    _createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.columnSort('menutype')))
                    }, "Menugruppe"),
                    _createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.columnSort('placering')))
                    }, "Menuplacering"),
                    _hoisted_16
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: menu.id
                  }, [
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(menu.id), 9, _hoisted_17),
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1)
                    }, _toDisplayString(menu.menu_titel), 9, _hoisted_18),
                    (menu.menu_type_id !== undefined && menu?.menu_type_id?.domaene_id !== undefined && menu?.menu_type_id?.domaene_id !== null)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'menustable-row' + (index+1)
                        }, _toDisplayString(_ctx.getFQDNOfDomainId(menu.menu_type_id.id)), 9, _hoisted_19))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          id: 'menustable-row' + (index+1)
                        }, "-", 8, _hoisted_20)),
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1)
                    }, _toDisplayString(_ctx.getFQDNOfURL(menu.menu_url)), 9, _hoisted_21),
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_icon, {
                        name: menu.menu_submenu ? 'check_box': 'check_box_outline_blank',
                        color: menu.menu_submenu ? 'primary' : 'rgb(255, 172, 10)'
                      }, null, 8, ["name", "color"]),
                      _createTextVNode(" " + _toDisplayString((_ctx.indexOfSubMenu = _ctx.getIndexOfMenuFromId(menu.menu_submenu_id)) >= 0 ? _ctx.allMenus[_ctx.indexOfSubMenu].menu_titel : '-- RODDEN --'), 1)
                    ], 8, _hoisted_22),
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1)
                    }, _toDisplayString(menu?.menu_type_id?.menu_type_titel), 9, _hoisted_23),
                    _createElementVNode("td", {
                      class: "center",
                      id: 'menustable-row' + (index+1)
                    }, _toDisplayString(menu?.menu_type_id?.menu_type_placering), 9, _hoisted_24),
                    _createElementVNode("td", {
                      id: 'menustable-row' + (index+1)
                    }, [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "info",
                            name: "editmenu",
                            onClick: ($event: any) => (_ctx.editMenu(menu?.id, menu?.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            class: "btn status-width",
                            icon: menu.menu_status ? 'check_box' : 'check_box_outline_blank',
                            color: menu.menu_status ? 'success' : 'rgb(255, 172, 10)',
                            name: "statusMenu",
                            onClick: ($event: any) => (_ctx.statusMenu(menu?.id, menu?.documentId))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menu.menu_status ? 'Aktiv' : 'Inaktiv'), 1)
                            ]),
                            _: 2
                          }, 1032, ["icon", "color", "onClick"]),
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "danger",
                            name: "deletemenu",
                            onClick: ($event: any) => (_ctx.deleteMenuWarning(menu?.id, menu?.documentId))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ], 8, _hoisted_25)
                  ]))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_31, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteMenuWarningModal,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.deleteMenuWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deleteMenu(this.deleteMenuId, this.deleteMenuDocumentId), _ctx.$Message.success({ text: 'Menupunktet er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.deleteMenuWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editMenuModal,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editMenuModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.updateMenu() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_49
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editMenuModal = false), _ctx.cancelMenuEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "editmenuModal",
              onClickOnce: _cache[33] || (_cache[33] = ($event: any) => (_ctx.templateGetPostPageURLs($event, true)))
            }, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("p", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.menuData.menuTitle), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.menuData.menuTitle,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.menuData.menuTitle) = $event)),
                    label: "Menupunktets titel",
                    placeholder: "Titeltekst",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_va_checkbox, {
                    class: "mb-4",
                    modelValue: _ctx.menuData.menuSubmenu,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.menuData.menuSubmenu) = $event)),
                    label: "Menupunktet kan have en eller flere undermenu(er)"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_va_select, {
                    label: "Tilhører Menugruppe",
                    class: "mb-4",
                    modelValue: _ctx.menuTypeTitleValue,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.menuTypeTitleValue) = $event)),
                    options: _ctx.menuTypeTitleOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_va_select, {
                    disabled: (_ctx.menuTypeTitleValue.value === '0'),
                    label: "Tilknyt menupunktet under menu",
                    class: "mb-4 center",
                    modelValue: _ctx.menuSubMenuTitleValue,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.menuSubMenuTitleValue) = $event)),
                    options: _ctx.menuSubMenuTitleOptions,
                    bordered: ""
                  }, null, 8, ["disabled", "modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_va_select, {
                    class: "mb-4 item center",
                    label: "Link til indlæg eller sider",
                    modelValue: _ctx.filterByPostTypeValue,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.filterByPostTypeValue) = $event)),
                    options: _ctx.filterByPostTypeOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode(_component_va_input, {
                    class: "mb-4 item",
                    label: "Hvad linker menupunktet til?",
                    modelValue: _ctx.menuURLValue.text,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.menuURLValue.text) = $event)),
                    clearable: "",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_va_input, {
                    class: "mb-4 center",
                    type: "text",
                    modelValue: _ctx.menuData.menuPosition,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.menuData.menuPosition) = $event)),
                    label: "Menupunktets position",
                    placeholder: "Positionsnr.",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ], 32)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger menupunkter']
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "tabHeight",
        onClickOnce: _cache[47] || (_cache[47] = ($event: any) => (_ctx.templateGetPostPageURLs($event, true)))
      }, [
        _createElementVNode("div", _hoisted_51, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newmenuform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuData.menuTitle,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.menuData.menuTitle) = $event)),
                                    type: "text",
                                    label: "Menupunktets titel",
                                    rules: [(menuTitle) => _ctx.menuData.menuTitle.length > 1 || 'Der mangler en titel'],
                                    placeholder: "Titeltekst",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _createVNode(_component_va_checkbox, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuData.menuSubmenu,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.menuData.menuSubmenu) = $event)),
                                    label: "Menupunktet kan have en eller flere undermenu(er)"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_va_select, {
                                    label: "Tilhører menugruppe",
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuTypeTitleValue,
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.menuTypeTitleValue) = $event)),
                                    options: _ctx.menuTypeTitleOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_va_select, {
                                    disabled: (_ctx.menuTypeTitleValue.value === '0'),
                                    label: "Tilknyt menupunktet under menu",
                                    class: "mb-4 item",
                                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.fillSubMenuTitleOptionsDataNew())),
                                    modelValue: _ctx.menuSubMenuTitleValue,
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.menuSubMenuTitleValue) = $event)),
                                    options: _ctx.menuSubMenuTitleOptions,
                                    bordered: ""
                                  }, null, 8, ["disabled", "modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createVNode(_component_va_select, {
                                    class: "mb-4 item center",
                                    label: "Link til indlæg eller sider",
                                    modelValue: _ctx.filterByPostTypeValue,
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.filterByPostTypeValue) = $event)),
                                    options: _ctx.filterByPostTypeOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"]),
                                  _createVNode(_component_va_select, {
                                    onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.templateGetPostPageURLs($event, false))),
                                    class: "mb-4 item",
                                    label: "Menupunktets link",
                                    modelValue: _ctx.menuURLValue,
                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.menuURLValue) = $event)),
                                    options: _ctx.menuURLOptions,
                                    allowCreate: "",
                                    onCreateNew: _ctx.addNewOption,
                                    clearable: "",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options", "onCreateNew"])
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item center",
                                    type: "number",
                                    modelValue: _ctx.menuData.menuPosition,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.menuData.menuPosition) = $event)),
                                    label: "Menupunktets position",
                                    rules: [(menuPosition) => _ctx.menuData.menuPosition.length > 0 || 'Der mangler et nummer'],
                                    placeholder: "Positionsnr.",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[46] || (_cache[46] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createMenu()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_68
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 544), [
        [_vShow, _ctx.tabValue ==='Opret nyt menupunkt']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Domænefilter",
              modelValue: _ctx.menuDomainFilterValue,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.menuDomainFilterValue) = $event)),
              options: _ctx.menuDomainFilterOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_73, [
              _createElementVNode("table", _hoisted_74, [
                _hoisted_75,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menutypes, (menutype, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: menutype.id
                  }, [
                    _createElementVNode("td", {
                      id: 'menutypestable-row' + (index+1),
                      hidden: ""
                    }, _toDisplayString(menutype.id), 9, _hoisted_76),
                    _createElementVNode("td", {
                      id: 'menutypestable-row' + (index+1)
                    }, _toDisplayString(menutype.menu_type_titel), 9, _hoisted_77),
                    (menutype.domaene_id !== undefined && menutype.domaene_id !== null && menutype.domaene_id.domaene_titel !== null)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          id: 'menutypestable-row' + (index+1)
                        }, _toDisplayString(menutype.domaene_id.domaene_titel), 9, _hoisted_78))
                      : (_openBlock(), _createElementBlock("td", {
                          key: 1,
                          id: 'menutypestable-row' + (index+1)
                        }, "-", 8, _hoisted_79)),
                    _createElementVNode("td", {
                      class: "center",
                      id: 'menutypestable-row' + (index+1)
                    }, _toDisplayString(menutype.menu_type_placering), 9, _hoisted_80),
                    _createElementVNode("td", {
                      id: 'menutypestable-row' + (index+1)
                    }, [
                      (menutype.id !== 9)
                        ? (_openBlock(), _createBlock(_component_va_button_group, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_va_button, {
                                class: "btn",
                                color: "info",
                                rounded: false,
                                name: "editmenutype",
                                onClick: ($event: any) => (_ctx.editMenuType(menutype.id, menutype.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_82
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_va_button, {
                                class: "btn status-width",
                                icon: menutype.menu_type_status ? 'check_box' : 'check_box_outline_blank',
                                color: menutype.menu_type_status ? 'success' : 'rgb(255, 172, 10)',
                                name: "statusMenuType",
                                onClick: ($event: any) => (_ctx.statusMenuType(menutype.id, menutype.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(menutype.menu_type_status ? 'Aktiv' : 'Inaktiv'), 1)
                                ]),
                                _: 2
                              }, 1032, ["icon", "color", "onClick"]),
                              _createVNode(_component_va_button, {
                                class: "btn",
                                color: "danger",
                                rounded: false,
                                name: "deletemenutype",
                                onClick: ($event: any) => (_ctx.deleteMenuTypeWarning(menutype.id, menutype.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_83
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_81)
                  ]))
                }), 128))
              ])
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteMenuTypeWarningModal,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.deleteMenuTypeWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "danger",
              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.deleteMenuType(this.deleteMenuTypeId, this.deleteMenuTypeDocumentId), _ctx.$Message.success({ text: 'Menugruppen er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_85
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn deletebuttonmargin",
              color: "secondary",
              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.deleteMenuTypeWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_86
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_84
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editMenuTypeModal,
          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.editMenuTypeModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.updateMenuType() ? _ctx.$Message.success({ text: 'Gemt succesfuldt' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_96
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editMenuTypeModal = false), _ctx.cancelMenuTypeEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_97
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("p", _hoisted_89, [
                  _hoisted_90,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.menuTypeData.menuTypeTitel), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createVNode(_component_va_input, {
                    class: "mb-4",
                    type: "text",
                    modelValue: _ctx.menuTypeData.menuTypeTitel,
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.menuTypeData.menuTypeTitel) = $event)),
                    label: "Menugruppenavn",
                    placeholder: "Navn",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_va_select, {
                    label: "Menugruppens placering",
                    class: "mb-4",
                    modelValue: _ctx.menuTypePlacementValue,
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.menuTypePlacementValue) = $event)),
                    options: _ctx.menuTypePlacementOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_component_va_select, {
                    label: "Menugruppens domæne",
                    class: "mb-4",
                    modelValue: _ctx.menuTypeDomainTitleValue,
                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.menuTypeDomainTitleValue) = $event)),
                    options: _ctx.menuTypeDomainTitleOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger menugrupper']
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "tabHeight",
        onClickOnce: _cache[63] || (_cache[63] = ($event: any) => (_ctx.templateGetDomains($event, true)))
      }, [
        _createElementVNode("div", _hoisted_98, [
          _hoisted_99,
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                (!_ctx.submitted2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newmenutypeform",
                          onSubmit: _ctx.handleSubmit
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuTypeData.menuTypeTitel,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.menuTypeData.menuTypeTitel) = $event)),
                                    type: "text",
                                    label: "Menugruppenavn",
                                    rules: [(menuTypeTitel) => _ctx.menuTypeData.menuTypeTitel.length > 1 || 'Der mangler et navn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _createVNode(_component_va_select, {
                                    label: "Menugruppens placering",
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuTypePlacementValue,
                                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.menuTypePlacementValue) = $event)),
                                    options: _ctx.menuTypePlacementOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("div", _hoisted_109, [
                                  _createVNode(_component_va_select, {
                                    onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.templateGetDomains($event, false))),
                                    label: "Menugruppens domæne",
                                    class: "mb-4 item",
                                    modelValue: _ctx.menuTypeDomainTitleValue,
                                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.menuTypeDomainTitleValue) = $event)),
                                    options: _ctx.menuTypeDomainTitleOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["onSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("div", _hoisted_111, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[62] || (_cache[62] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createMenuType()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_112
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 544), [
        [_vShow, _ctx.tabValue === 'Opret ny menugruppe']
      ])
    ])
  ]))
}